<template>
  <div class="project-base">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "ProjectBase"
};
</script>

<style lang="scss">
.project-base {
  height: calc(100% - 60px);

  .project-base {
    height: 100%;
  }
}
</style>
